export const overlaps = (aStart, aEnd, bStart, bEnd) => aEnd > bStart && aStart < bEnd;

export const asRooms = (p) =>
  Array.isArray(p?.data)
    ? p.data
    : Array.isArray(p?.data?.rooms)
    ? p.data.rooms
    : Array.isArray(p?.rooms)
    ? p.rooms
    : Array.isArray(p)
    ? p
    : [];

export const asReservations = (p) =>
  Array.isArray(p?.data?.reservationData)
    ? p.data.reservationData
    : Array.isArray(p?.reservationData)
    ? p.reservationData
    : Array.isArray(p?.data)
    ? p.data
    : Array.isArray(p)
    ? p
    : [];
